import { Component } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import {ENTER, COMMA, TAB} from '@angular/cdk/keycodes';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-string-list-input',
    templateUrl: './string-list-input.component.html',
    styleUrls: ['./string-list-input.component.css'],
    standalone: false
})
export class StringListInputComponent extends BaseFormInput {
  separatorKeysCodes = [ENTER, COMMA, TAB];
  changed = false;

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      const currentList = this.currentStrings();
      if (currentList.indexOf(value) === -1) {
        this.field.control.setValue([...currentList, value])
        this.field.control.markAsDirty();
      }
    }

    // Reset the actual field input value as the string list renders itself as an overlay
    event.chipInput.clear();

    this.changed = true;
  }

  remove(stringToRemove: string): void {
    const newStrings = this.currentStrings().filter((s: string) => s !== stringToRemove);
    this.field.control.setValue(newStrings);
    this.field.control.markAsDirty();
    this.changed = true;
  }

  currentStrings() {
    return this.field.control.value || [];
  }

  showDanger() {
    return (this.changed || !!this.field.form?.submitted) && !this.field.control.valid;
  }
}
